var _jsxFileName = "/home/christian/DEV/workspace/crossbuilders/form-library/src/lib/components/structure/Label/index.jsx";
import React from 'react';
import PropTypes from 'prop-types';
export default function Label(props) {
  var id = props.id,
    className = props.className,
    children = props.children;
  if (!children) {
    return null;
  }
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: className,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 9
    }
  }, children);
}
Label.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string
};
Label.defaultProps = {
  className: 'form-label'
};